import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Auth
      'login': 'Login',
      'register': 'Register',
      'email': 'Email',
      'password': 'Password',
      'fullName': 'Full Name',
      'logout': 'Logout',
      
      // Navigation
      'dashboard': 'Dashboard',
      'pools': 'Pools',
      'readings': 'Daily Readings',
      'users': 'Users',
      
      // Pool Management
      'addPool': 'Add Pool',
      'editPool': 'Edit Pool',
      'deletePool': 'Delete Pool',
      'propertyName': 'Property Name',
      'poolName': 'Pool Name',
      'address': 'Address',
      'contactInfo': 'Contact Information',
      'volume': 'Volume',
      'qrCode': 'QR Code',
      
      // Daily Readings
      'addReading': 'Add Reading',
      'date': 'Date',
      'ph': 'pH',
      'chlorine': 'Chlorine (ppm)',
      'calciumHardness': 'Calcium Hardness (ppm)',
      'alkalinity': 'Alkalinity (ppm)',
      'waterTemp': 'Water Temperature (°F)',
      'cyanuricAcid': 'Cyanuric Acid (ppm)',
      'tds': 'Total Dissolved Solids (ppm)',
      'backwashDate': 'Backwash Date',
      'notes': 'Notes',
      
      // Actions
      'save': 'Save',
      'cancel': 'Cancel',
      'delete': 'Delete',
      'edit': 'Edit',
      'view': 'View',
      'export': 'Export to Spreadsheet',
      'generateQR': 'Generate QR Code',
      
      // User Management
      'role': 'Role',
      'admin': 'Admin',
      'staff': 'Staff',
      'viewer': 'Viewer',
      
      // Messages
      'loginSuccess': 'Logged in successfully',
      'loginError': 'Invalid credentials',
      'saved': 'Saved successfully',
      'deleted': 'Deleted successfully',
      'error': 'An error occurred',
      
      // Public View
      'publicView': 'Public Pool Compliance View',
      'last30Days': 'Last 30 Days',
      'noData': 'No data available'
    }
  },
  es: {
    translation: {
      // Auth
      'login': 'Iniciar Sesión',
      'register': 'Registrarse',
      'email': 'Correo Electrónico',
      'password': 'Contraseña',
      'fullName': 'Nombre Completo',
      'logout': 'Cerrar Sesión',
      
      // Navigation
      'dashboard': 'Panel',
      'pools': 'Piscinas',
      'readings': 'Lecturas Diarias',
      'users': 'Usuarios',
      
      // Pool Management
      'addPool': 'Agregar Piscina',
      'editPool': 'Editar Piscina',
      'deletePool': 'Eliminar Piscina',
      'propertyName': 'Nombre de Propiedad',
      'poolName': 'Nombre de Piscina',
      'address': 'Dirección',
      'contactInfo': 'Información de Contacto',
      'volume': 'Volumen',
      'qrCode': 'Código QR',
      
      // Daily Readings
      'addReading': 'Agregar Lectura',
      'date': 'Fecha',
      'ph': 'pH',
      'chlorine': 'Cloro (ppm)',
      'calciumHardness': 'Dureza de Calcio (ppm)',
      'alkalinity': 'Alcalinidad (ppm)',
      'waterTemp': 'Temperatura del Agua (°F)',
      'cyanuricAcid': 'Ácido Cianúrico (ppm)',
      'tds': 'Sólidos Disueltos Totales (ppm)',
      'backwashDate': 'Fecha de Retrolavado',
      'notes': 'Notas',
      
      // Actions
      'save': 'Guardar',
      'cancel': 'Cancelar',
      'delete': 'Eliminar',
      'edit': 'Editar',
      'view': 'Ver',
      'export': 'Exportar a Hoja de Cálculo',
      'generateQR': 'Generar Código QR',
      
      // User Management
      'role': 'Rol',
      'admin': 'Administrador',
      'staff': 'Personal',
      'viewer': 'Visor',
      
      // Messages
      'loginSuccess': 'Sesión iniciada correctamente',
      'loginError': 'Credenciales inválidas',
      'saved': 'Guardado correctamente',
      'deleted': 'Eliminado correctamente',
      'error': 'Ocurrió un error',
      
      // Public View
      'publicView': 'Vista Pública de Cumplimiento de Piscina',
      'last30Days': 'Últimos 30 Días',
      'noData': 'No hay datos disponibles'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;